import { atom } from 'jotai';
import { Teacher, User } from '../types/api';
import { cookieAuth } from '../utils/cookieAuth';

// 인증 상태
export interface AuthState {
  isAuthenticated: boolean;
  userType: 'teacher' | 'user' | null;
  userInfo: Teacher | User | null;
  loading: boolean;
}

// 쿠키에서 초기 상태 로드
const getInitialAuthState = (): AuthState => {
  try {
    const storedData = cookieAuth.getUserInfo();
    if (storedData && storedData.userInfo && storedData.userType) {
      return {
        isAuthenticated: true,
        userType: storedData.userType,
        userInfo: storedData.userInfo,
        loading: false,
      };
    }
  } catch {
    // 쿠키에서 초기 인증 상태 로드 실패
  }

  return {
    isAuthenticated: false,
    userType: null,
    userInfo: null,
    loading: false,
  };
};

export const authState = atom<AuthState>(getInitialAuthState());
